import * as v from "valibot";
import { api } from "./contract";
import { SEROPHIN_SSM_PREFIX } from "./serophin-params";

export const SEROPHIN_ADMIN_HEADER = "x-serophin-admin";

export const SEROPHIN_ADMIN_ROLE_NAME = "serophin-admin-api";

export const SEROPHIN_ADMIN_PATH_PREFIX = "/api/admin/";

export const serophinAdminUrlParam = (app: string, env: string): string => `${SEROPHIN_SSM_PREFIX}/${app}-${env}/admin-url`;

export const adminPingResponse = { app: v.string(), env: v.string(), admin: v.string() };

export type AdminPingResponse = v.InferOutput<v.ObjectSchema<typeof adminPingResponse, undefined>>;

export const adminPingApi = api("GET", "/admin/ping").withResponse(adminPingResponse);
